<template>
  <div class="div1" id="chatArea" ref="chatArea">
    <div class="div2">
      <!-- 先循环找到你想要聊天的那个人 -->
      <div class="loadMsg" v-if="msgList.length >= 100 && count > 100 && msgList.length != count">
        {{ loadMsg }}
      </div>
      <div class="msg_box">
        <!-- 再循环显示聊天记录 -->
        <p>
          <el-avatar :src="HZimg"></el-avatar>
        </p>
        <div class="box-card">
          <div slot="header" class="box-card-header">
            <span>病历</span>
          </div>
          <div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>患病时长：</strong></span>
              <span class="txt">{{ illTime }}</span>
            </div>
            <div v-if="record.diagnosisImg">
              <span v-for="(item, index3) in record.diagnosisImg" :key="index3">
                <el-image :src="item" :preview-src-list="[item]" alt="" style="width: 126px; height: 120px"></el-image>
              </span>
            </div>

            <div>
              <div class="FlexTxt">
                <span class="txtLable"><strong>线下确诊：</strong></span><span class="txt">{{ record.illName }}</span>
              </div>
            </div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>既往史：</strong></span><span class="txt">{{ record.diseaseHistory }}</span>
            </div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>手术史：</strong></span><span class="txt">{{ record.operHistory }}</span>
            </div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>婚育史：</strong></span><span class="txt">{{ record.marryHistory }}</span>
            </div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>家族史：</strong></span><span class="txt">{{ record.familyHistory }}</span>
            </div>
            <div class="FlexTxt">
              <span class="txtLable"><strong>药物过敏史：</strong></span>
              <span class="txt" v-if="record.allergyFlag == 0">无</span>
              <span class="txt" v-else>{{ record.allergyName }}</span>
            </div>
            <!-- <div v-if="record.allergyFlag == 0" class="txtLable"><strong>无药物过敏史&nbsp;&nbsp;</strong></div>
            <div v-else class="txtLable">
              <strong>有药物过敏史：</strong>
              <span span class="txtLable">{{
                record.allergyName
              }}</span>
            </div> -->
            <div class="FlexTxt"><span class="txtLable"><strong>肝功能状态：</strong></span>
              <span v-if="record.liverFunction == 'NORMAL'">正常</span>
              <span v-else-if="record.liverFunction == 'ABNORMAL'">异常</span>
              <span v-else-if="record.liverFunction == 'UNKOWN'">未知</span>
            </div>
            <div class="FlexTxt"><span class="txtLable"><strong>肾功能状态：</strong></span>
              <span v-if="record.renalFunction == 'NORMAL'">正常</span>
              <span v-else-if="record.renalFunction == 'ABNORMAL'">异常</span>
              <span v-else-if="record.renalFunction == 'UNKOWN'">未知</span>
            </div>
            <div>
              <div class="FlexTxt">
                <span class="txtLable"><strong>病情描述：</strong></span><span class="txt">{{ record.illDesc }}</span>
              </div>
            </div>
            <!-- <div v-if="record.otherSickFlag == 0">
              无肝、肾功能异常或家族病史
            </div>
            <div v-else>
              <span class="warningIcon">!</span>有肝、肾功能异常或家族病史
            </div> -->
          </div>
        </div>
      </div>
      <div v-for="(list, index) in msgList" :key="list.id || index">
        <div v-if="list.type == 0 || list.type == 3 || list.type == 10 || list.type == 8">
          <!-- 根据接收者和发送者定位聊天记录 -->
          <div class="msg_box" :class="{ myType: list.sendType == 2 }">
            <!-- 再循环显示聊天记录 -->
            <p style="max-width: 50%" class="flexBox">
              <el-avatar v-if="(list.sendType == 1 && list.contentType == 0) || !list.sendType" :src="HZimg"
                         style="vertical-align: middle; margin-right: 10px" class="touxiang"></el-avatar>
              <span class="content" v-if="list.sendType == 2 && list.contentType == 0">{{ list.contentData }}</span>
              <el-avatar v-if="list.sendType == 2 && list.contentType == 0" :src="doctorIMG" style="margin-left: 10px"
                         class="touxiang"></el-avatar>

              <span style="
                  background: #fff;
                  padding: 10px;
                  border-radius: 10px;
                  padding-right: 16px;
                " class="content" v-if="list.sendType == 1 && list.contentType == 0 || !list.sendType">
                {{ list.contentData }}
              </span>
            </p>
            <p style="max-width: 50%" class="flexBox" :style="{
              'justify-content':
                list.sendType == '1' ? 'flex-start' : 'flex-end',
            }">
              <el-avatar v-if="list.sendType == 1 && list.contentType == 1" :src="HZimg"
                         style="vertical-align: middle; margin-right: 10px" class="touxiang"></el-avatar>
              <el-image v-if="list.sendType == 1 && list.contentType == 1 && list.imgUrl" class="imgStyle"
                        :src="list.imgUrl" :preview-src-list="[list.imgUrl]" @error="reLoadImg" lazy>
              </el-image>
              <div v-if="list.contentType == 1 && !list.imgUrl"
                   style="background:grey;color:#fff;line-height:200px;border-radius: 10px;padding:0px 10px;">图片加载中
              </div>
              <el-image v-if="list.sendType == 2 && list.contentType == 1 && list.imgUrl" class="imgStyle"
                        :src="list.imgUrl" :preview-src-list="[list.imgUrl]" @error="reLoadImg" lazy>
              </el-image>
              <el-avatar v-if="list.sendType == 2 && list.contentType == 1" :src="doctorIMG" style="margin-left: 10px"
                         class="touxiang"></el-avatar>

            </p>
          </div>
        </div>
        <div v-if="list.type == 6" class="CFBOX">
          <table class="CF_box">
            <div class="CF_boxthead">
              <div>处方</div>
              <div>{{ list.contentData.openTime }}</div>
            </div>
            <tr>
              <td>
                <span>处方类别：</span>
                <span v-if="list.contentData.rxTypeCode == '1'">门诊西药</span><span
                  v-if="list.contentData.rxTypeCode == '2'">门诊中药饮片</span><span
                  v-if="list.contentData.rxTypeCode == '3'">急诊西药</span><span
                  v-if="list.contentData.rxTypeCode == '4'">急诊中药饮片</span><span
                  v-if="list.contentData.rxTypeCode == '5'">儿科西药</span><span
                  v-if="list.contentData.rxTypeCode == '6'">儿科中药饮片</span><span
                  v-if="list.contentData.rxTypeCode == '7'">麻、精一</span><span
                  v-if="list.contentData.rxTypeCode == '8'">精二</span><span
                  v-if="list.contentData.rxTypeCode == '9'">中药饮片</span><span
                  v-if="list.contentData.rxTypeCode == '10'">中成药</span><span
                  v-if="list.contentData.rxTypeCode == '99'">其它</span>
                <span v-if="list.contentData.rxTypeCode == ''"></span>
                <!-- <span>{{ this.rxTypeCode }}</span> -->
              </td>
            </tr>
            <tr>
              <td>
                <span>诊断名称：</span><span>{{ list.contentData.diagName }}</span><span></span>
              </td>
            </tr>
            <tr>
              <td>
                <span>处方药品：</span>
              </td>
            </tr>
            <div v-for="(item, index2) in list.contentData.prescriptionDrugList" :key="'infoB-' + index2">
              <!-- 西药处方显示完整信息 -->
              <template
                  v-if="list.contentData.rxTypeCode == '1' || list.contentData.rxTypeCode == '3' || list.contentData.rxTypeCode == '5' || list.contentData.rxTypeCode == '7' || list.contentData.rxTypeCode == '8'">
                <tr>
                  <td>
                    <span>药品：</span><span>{{ item.drugName }}</span>
                  </td>
                  <td>
                    <span>规格：</span><span>{{ item.specification }}</span>
                  </td>
                  <td>
                    <span>数量：</span><span>{{ item.drugNumber }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>频次：</span><span>{{ item.frquName }}</span>
                  </td>
                  <td>
                    <span>用法：</span><span>{{ item.wayName }}</span>
                  </td>
                  <td>
                    <span>天数：</span><span>{{ item.days }}天</span>
                  </td>
                </tr>
              </template>
              
              <!-- 中药处方只显示药品和数量 -->
              <template v-else>
                <tr>
                  <td>
                    <span>药品：</span><span>{{ item.drugName }}</span>
                  </td>
                  <td>
                    <span>数量：</span><span>{{ item.drugNumber }}</span>
                  </td>
                </tr>
              </template>
            </div>
            <tr>
              <td>
                <span>注意事项：</span><span>{{ list.contentData.note }}</span>
              </td>
            </tr>
          </table>
          <p>
            <el-avatar :src="doctorIMG"></el-avatar>
          </p>
        </div>
      </div>
      <el-dialog :visible.sync="tipsFlag2" width="30%" :show-close="false" :close-on-click-modal="false"
                 class="tipsMsgBox" :modal="false">
        <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from "../../../../store/store";
import doctorIMG from "../../../../img/doctor.png";
import HZimg from "../../../../img/患者.png";
import {imgDownLoad, msgList} from "@/api/index";

export default {
  data() {
    return {
      myFlag: "",
      recordData: {},
      list: [],
      doctorIMG: doctorIMG,
      HZimg: HZimg,
      loadFlag: true,
      loadMsg: "上拉加载历史记录",
      chatData: [],
      count: "",
      msgCp: 1,
      tipsFlag2: false,
      tipsMsg: "",
      firstLoad: true,
      historyFlag: false,
      countDown: 1,
      orderNumber: "",
      scrollHeight: "",
      illTime: "",
      sendImgData: {},
      loading: true,
      loadHistoryFlag: true,
      msgPollingTimer: null,
    };
  },
  props: {
    recordFlag: {
      type: String,
      default: "",
    },
  },
  watch: {
    setOrderNumber() {
      if (this.orderNumber != store.state.orderNumber) {
        this.loadFlag = true;
        this.msgCp = 1;
        this.loadHistoryFlag = false;
        this.orderNumber = JSON.parse(JSON.stringify(store.state.orderNumber));
        this.loadMsgList();
        this.firstLoad = true;
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    getMsg(newData, o) {
      // console.log(newData,"newData:::")
      if (this.loadFlag) {
        let flag = false;
        this.chatData.forEach((item) => {
          if (item.type == 3) {
            flag = true;
          }
        });
        this.chatData.push(newData);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    loadFLag() {
    },
    showMsgFlag() {
    },
    sendImg() {
      this.chatData.push(this.sendImgData);
    },
    chatData() {

      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
  },
  mounted() {
    const scrollview = this.$refs["chatArea"];
    scrollview.addEventListener("scroll", this.scrollChange, true);
    this.$nextTick(() => {
      this.scrollToBottom();
      // 如果已经有订单号，立即加载聊天记录
      if (store.state.orderNumber) {
        console.log('mounted时检测到订单号，立即加载聊天记录:', store.state.orderNumber);
        this.orderNumber = store.state.orderNumber;
        this.loadMsgList();
      }
    });
    this.stopMsgPolling();
  },
  beforeDestroy() {
    this.stopMsgPolling();
  },
  activated() {
    this.startMsgPolling();
    if (store.state.StatusFlag && store.state.orderNumber && this.orderNumber !== store.state.orderNumber) {
      this.refreshChatData();
    }
  },
  deactivated() {
    this.stopMsgPolling();
  },
  computed: {
    msgList() {
      // 非接诊状态直接不显示任何消息
      if (!store.state.StatusFlag || !store.state.orderNumber) {
        return [];
      }
      let list = this.chatData;
      if (!this.historyFlag || this.firstLoad == true) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } else {
      }
      let num = list;
      // store.commit("SET_CF_FLAG", false);
      if (num) {
        store.commit("SET_SCORLLFLAG", num.length);
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
      return list;
    },
    myInfo() {
      return store.state.myInfo;
    },
    userInfo() {
      return store.state.userInfo;
    },
    async setOrderNumber() {
      if (store.state.orderNumber != this.orderNumber) {
        this.list = [];
      }
      return store.state.orderNumber;
    },
    record() {
      let record_data = store.state.recordData;
      let splitFlag = record_data.diagnosisImg instanceof Array;
      if (record_data.diagnosisImg && splitFlag == false) {
        const diagnosisImg = record_data.diagnosisImg.split("|");
        record_data.diagnosisImg = []
        diagnosisImg.map((item) => {
          imgDownLoad({
            path: item,
          }).then((res) => {
            record_data.diagnosisImg.push("data:image/jpeg;base64," + res.data);
          })
        });
      }
      switch (record_data.illTime) {
        case 1:
          this.illTime = "一个月内";
          break;
        case 2:
          this.illTime = "半年内";
          break;
        case 3:
          this.illTime = "一年内";
          break;
        case 4:
          this.illTime = "一年以上";
          break;
      }
      return record_data;
    },
    getMsg() {
      var getMsg = JSON.parse(JSON.stringify(store.state.chatMessageList));
      // let count = JSON.parse(JSON.stringify(store.state.count));

      //   store.commit("SET_COUNT", 1);
      // }
      return getMsg;
    },
    showMsgFlag() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
      return store.state.showMsgFlag;
    },
    sendImg() {
      let sendImg = store.state.sendImg;
      this.sendImgData = {
        sendType: 2,
        type: 0,
        contentType: 1,
        imgUrl: store.state.sendImg.base64,
      };
      this.$nextTick(() => {
        this.scrollToBottom();
      });
      return sendImg;
    },
  },

  methods: {
    scrollToBottom() {
      let chat = document.querySelector(".div1");
      // if (this.mountedFlag == true) {
      //   this.mountedFlag = false;
      // }
      // this.scrollHeight = chat.scrollHeight;
      chat.scrollTop = chat.scrollHeight;
    },
    refreshChatData() {
      if (store.state.orderNumber) {
        this.orderNumber = store.state.orderNumber;
        this.loadFlag = true;
        this.msgCp = 1;
        this.loadHistoryFlag = false;
        this.firstLoad = true;
        this.loadMsgList();
      }
    },

    loadMsgList(isSilent = false) {
      // this.loading = true;
      // setTimeout(()=>{
      //   this.loading = false;
      // },10000)
      var loadList = [];
      if (store.state.orderNumber) {
        let postData = {
          orderNumber: store.state.orderNumber,
          cp: this.msgCp,
          lz: 100,
        };
        msgList(postData, isSilent).then(async (data) => {
          // 如果正在看图，且没有新消息，直接拦截
          if (isSilent && data.data.count == this.count) {
            return;
          }
          // 如果正在看图且有新消息，跳过，关了图等待下次轮询
          if (isSilent && document.querySelector('.el-image-viewer__wrapper')) {
            return;
          }
          if (!isSilent) {
            this.loadMsg = "加载中";
          }
          if (data.code == 0) {
            if (!this.historyFlag) {
              loadList = JSON.parse(JSON.stringify(data.data.data.reverse()));
              this.count = data.data.count;
              await loadList.forEach(async (item) => {
                if (item.type == "6" && typeof item.contentData == "string") {
                  item.contentData = JSON.parse(item.contentData);
                  this.createTime = item.createTime;
                }
                if (item.type == 3) {
                  item.contentData = JSON.parse(item.contentData).message;
                  this.refundButtonFlag = false;
                }
                if (item.contentType == 1) {
                  let imgPostData = {
                    path: item.contentData,
                  };
                  await imgDownLoad(imgPostData).then(async (res) => {
                    if (res.code == 0) {
                      item.imgUrl = "data:image/jpeg;base64," + res.data;
                      this.$forceUpdate();
                      if (!isSilent) {
                        this.chatData = loadList;
                      }
                    }
                  });
                }
              });
              this.chatData = loadList;
              this.$forceUpdate();
              this.$nextTick(() => {
                this.scrollToBottom();
              });
            } else {
              let getData = data.data.data.reverse();
              this.chatData.forEach((item) => {
                getData.push(item);
              });
              this.chatData = getData;
              this.chatData.forEach(async (item) => {
                if (item.type == "6" && typeof item.contentData == "string") {
                  item.contentData = JSON.parse(item.contentData);
                  this.createTime = item.createTime;
                }
                if (item.type == 3) {
                  this.refundButtonFlag = false;
                }
                if (item.contentType == 1) {
                  let imgPostData = {
                    path: item.contentData,
                  };
                  await imgDownLoad(imgPostData).then((res) => {
                    if (res.code == 0) {
                      item.imgUrl = "data:image/jpeg;base64," + res.data;
                    }
                  });
                }
              });
              this.chatData = JSON.parse(JSON.stringify(this.chatData));
            }
            this.loadFlag = true;
          } else {
            if (!isSilent) {
              this.tipsFlag2 = true;
              this.tipsMsg = data.msg;
              setTimeout(() => { this.tipsFlag2 = false; }, 2000);
            }
          }
          this.loadMsg = "上拉加载更多";
          // this.loading = false;
        });
      }
    },
    async scrollChange() {
      let chat = document.querySelector(".div1");
      this.scrollHeight = chat.scrollHeight - 408;
      if (
          chat.scrollTop == 0 &&
          this.count > 100 &&
          this.msgList.length < this.count &&
          this.loadHistoryFlag
      ) {
        this.msgCp++;
        await this.loadMsgList();
        this.historyFlag = true;
        await (chat.scrollTop = chat.scrollHeight + this.scrollHeight);
        await (this.mountedFlag = true);
      } else if (this.cp > this.countFlag) {
      } else if (!this.loadHistoryFlag) {
        this.loadHistoryFlag = true;
      }
    },
    startMsgPolling() {
      this.stopMsgPolling();
      this.msgPollingTimer = setInterval(() => {
        if (store.state.StatusFlag && store.state.orderNumber) {
          this.loadMsgList(true); // 传入 true 实现静默
        }
      }, 60000);
    },
    stopMsgPolling() {
      if (this.msgPollingTimer) {
        clearInterval(this.msgPollingTimer);
        this.msgPollingTimer = null;
      }
    },
    reLoadImg() {
      this.$forceUpdate();
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
  },
};
</script>
<style scoped>
.div1 {
  height: 100%;
  overflow-x: auto;
  overflow-y: auto;
  /* 添加垂直滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #c0c4cc #f5f7fa;
}

/* 自定义滚动条样式 */
.div1::-webkit-scrollbar {
  width: 6px;
}

.div1::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

.div1::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.div1::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.div2 {
  box-sizing: border-box;
  padding-right: 8px;
  padding-bottom: 20px; /* 添加底部间距，确保最后一条消息完全可见 */
  width: 100%;
}

.div2 .myType {
  position: relative;
}

.content {
  background-color: rgb(149, 236, 105);
  padding: 10px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  word-break: break-all;
  max-width: 84%;
}

.right {
  text-align: right;
}

.msg_box {
  margin-bottom: 14px;
  display: flex;
}

.box-card {
  width: 40%;
  margin-left: 10px;
  max-width: 400px;
  border-radius: 10%;
  background-color: #fff;
}

.box-card .box-card-header {
  padding: 8px;
  border-radius: 5% 5% 0 0/15% 15% 0 0;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.5);
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  background-color: #0caf60;
}

.box-card img {
  width: 126px;
  height: 120px;
}

.box-card > div {
  padding: 8px;
  line-height: 26px;
}

.box-card .txt {
  word-break: break-all;
}

.box-card .FlexTxt {
  display: flex;
  flex-shrink: 0;
}

.box-card .FlexTxt .cardLable1 {
  width: 140px;
}

.box-card .FlexTxt .cardLable2 {
  width: 126px;
}

.box-card .el-card__body .el-button {
  text-align: center;
  width: 100%;
}

.prescriptionBox {
  max-width: 400px;
}

.myType {
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 1;
}

.myType span {
  float: right;
}

.FlexTxt > .txt {
  flex-shrink: 1;
}

.FlexTxt .txtLable {
  flex-shrink: 0;
  width: 98px;
  text-align: right;
}

.CFBOX {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.CF_box {
  border-radius: 10%;
  min-width: 344px;
  margin-right: 10px;
  background: #fff;
}

.CF_box .CF_boxthead {
  padding: 8px;
  border-radius: 5% 5% 0 0/26% 26% 0 0;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  background: #0caf60;
}

.CF_box td {
  padding: 4px 10px;
}

.loadMsg {
  margin-bottom: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a0aec0;
  text-align: center;
}

.warningIcon {
  box-sizing: border-box;
  color: #fff;
  background: #faad14;
  border-radius: 50%;
  padding: 0px 8px;
  margin-right: 8px;
}

.touxiang,
.touxiang > img {
  display: inline-block;
  width: 40px;
}

.imgStyle {
  /* width: auto;
  height: 100px; */
  height: auto;
  width: auto;
  max-width: 200px;
  height: 200px;
}

.imgStyle /deep/ img {
  max-width: 200px;
  height: 200px;
}

.myType .flexBox {
  justify-content: right;
}

@media only screen and (max-height: 550px) {
  .content {
    max-width: 74%;
  }

  #app {
    max-height: 550px;
    overflow: scroll;
  }
}

@media only screen and (max-width: 1000px) {
  .content {
    max-width: 70%;
  }
}
</style>